import AmplienceConfig from '../config/amplience.json'

const buildImgUrlFromDerivative = (derivative, channelInfo, imgUrl) => {
  const { imageTemplate } = derivative
  const parameters = [channelInfo, imageTemplate]
  const queryString = parameters.filter(value => value).join('&')
  return `${imgUrl}?${queryString}`
}

const buildImageUrl = ({ imgUrl, width, height, templateType }) => {
  const { channelInfo, derivatives, emptyDerivative } = AmplienceConfig
  const derivativeTypeList = derivatives[templateType] || []
  const findMatchingDerivative = item => width <= item.width && height <= item.height
  const derivative = derivativeTypeList.find(findMatchingDerivative) || emptyDerivative
  return buildImgUrlFromDerivative(derivative, channelInfo, imgUrl)
}

const buildProductImagePlaceholder = () => `//${AmplienceConfig.hostname}/i/Argos/prod-img-placeholder`

const buildProductImageBaseUrl = partNumber => `//${AmplienceConfig.hostname}/s/Argos/${partNumber}_R_SET`

export { AmplienceConfig, buildProductImageBaseUrl, buildImageUrl, buildProductImagePlaceholder }
